import React, { useRef, useEffect } from "react";

const CanvasImage = ({ imageObj, maxWidth = 500, maxHeight = 500, coordinates = [] }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !imageObj) return;

    const ctx = canvas.getContext("2d");

    const scale = Math.min(maxWidth / imageObj.width, maxHeight / imageObj.height);
    const scaledWidth = imageObj.width * scale;
    const scaledHeight = imageObj.height * scale;

    canvas.width = scaledWidth;
    canvas.height = scaledHeight;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(imageObj, 0, 0, scaledWidth, scaledHeight);

    coordinates.forEach(({ coords, color }) => {
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      coords.forEach(([x1, y1, x2, y2]) => {
        const rectX = x1 * scale;
        const rectY = y1 * scale;
        const rectWidth = (x2 - x1) * scale;
        const rectHeight = (y2 - y1) * scale;
        ctx.strokeRect(rectX, rectY, rectWidth, rectHeight);
      });
    });
  }, [imageObj, maxWidth, maxHeight, coordinates]);

  return <canvas ref={canvasRef} style={{ maxWidth: "100%", height: "auto", borderRadius: 8 }} />;
};

export default CanvasImage;
